import React, { lazy } from "react";

const LazyDownloads = lazy(() => import("./Downloads"));

const Downloads = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => <LazyDownloads {...props} />;

export default Downloads;
